<mat-spinner *ngIf="isLoading" class="loading-spinner"></mat-spinner>

<div class="container-internships" *ngIf="!isLoading">
  <app-alert-message></app-alert-message>

  <div class="container-top">
    <header>
      <h1>{{ "header.internships" | translate }}</h1>
      <p>{{ "internships.description" | translate }}</p>
    </header>

    <div class="pulsanti">
      <button
        class="addButton"
        (click)="openAddInternshipDialog()"
        [disabled]="!isAddAvailable"
        [matTooltip]="addTooltipKey ? (addTooltipKey | translate) : ''"
        matTooltipPosition="below"
      >
        <mat-icon>add</mat-icon>{{ "internships.create" | translate }}
      </button>
    </div>
  </div>

  <div class="container-bottom">
    <div class="top">
      <!-- <div class="filtro-nome">
        <label class="mat-label">Search the trainee</label><br>
        <div class="mat-input-wrapper">
          <input
            type="text"
            [(ngModel)]="filterValue"
            (input)="applyFilter()"
            placeholder="Mario, Bianchi..."
            class="mat-input"
          >
        </div>
      </div>

      <div class="filtro-tutor">
        <label class="mat-label">Search for supervisor</label><br>
        <div class="mat-input-wrapper">
          <input
            type="text"
            [(ngModel)]="tutorFilter"
            (input)="applyFilter()"
            placeholder="Nome tutor..."
            class="mat-input"
          >
        </div>
      </div> -->

      <div class="filtro-search">
        <label class="mat-label">{{
          "available-internships.global-search.label" | translate
        }}</label
        ><br />
        <div class="mat-input-wrapper">
          <input
            type="text"
            [(ngModel)]="globalFilter"
            (input)="applyFilter()"
            placeholder="{{
              'internships.global-search.placeholder' | translate
            }}"
            class="mat-input"
          />
        </div>
      </div>

      <div class="filtro-status">
        <label class="mat-label">{{
          "internships.status.label" | translate
        }}</label
        ><br />
        <div class="mat-input-wrapper">
          <select
            id="statusSelect"
            [(ngModel)]="statusFilter"
            (change)="applyFilter()"
            class="mat-input"
          >
            <option value="">
              {{ "available-internships.visibility.all" | translate }}
            </option>
            <option value="Planned">
              {{ "common.status.planned" | translate }}
            </option>
            <option value="Ongoing">
              {{ "common.status.ongoing" | translate }}
            </option>
            <option value="Completed">
              {{ "common.status.completed" | translate }}
            </option>
          </select>
        </div>
      </div>

      <!-- Filtro per stato del tirocinio -->
      <!-- <mat-form-field appearance="outline">
          <mat-label>Status</mat-label>
          <mat-select [(value)]="statusFilter" (selectionChange)="applyFilter()">
              <mat-option value="">All</mat-option>
              <mat-option value="Active">Active</mat-option>
              <mat-option value="Completed">Completed</mat-option>
              <mat-option value="Paused">Paused</mat-option>
          </mat-select>
      </mat-form-field> -->

      <div class="filtro-date" [formGroup]="dateRange">
        <label class="mat-label">{{
          "all-trainee-assessments.date-range" | translate
        }}</label
        ><br />

        <div class="mat-input-wrapper">
          <input type="date" formControlName="start" class="mat-input date-filter" />
          <span class="divider">–</span>
          <input type="date" formControlName="end" class="mat-input date-filter" />
        </div>
      </div>

      <div class="filtro-questionnaire">
        <label class="mat-label">{{
          "internships.questionnaire.label" | translate
        }}</label
        ><br />
        <div class="mat-input-wrapper">
          <select
            id="questionnaireSelect"
            [(ngModel)]="questionnaireCompiledFilter"
            (change)="applyFilter()"
            class="mat-input"
          >
            <option value="">
              {{ "available-internships.visibility.all" | translate }}
            </option>
            <option value="YES">{{ "common.yes" | translate }}</option>
            <option value="NO">{{ "common.no" | translate }}</option>
          </select>
        </div>
      </div>

      <div class="pulsanti">
        <button class="clearFilter" (click)="clearFilters()">
          <mat-icon>filter_alt_off</mat-icon
          >{{ "available-internships.clear" | translate }}
        </button>
      </div>
    </div>

    <div class="bottom">
      <ng-container *ngIf="dataSource.data.length > 0; else noInternships">
        <!-- VERSIONE DESKTOP  -->
        <div class="desktop-cards">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
            <!-- Select Column -->
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let row"></td>
            </ng-container>

            <!-- Durata Column -->
            <ng-container matColumnDef="duration">
              <th mat-header-cell *matHeaderCellDef>
                {{ "internships.table.duration" | translate }}
              </th>
              <td mat-cell *matCellDef="let internship">
                <div class="duration-cell">
                  <div class="duration-startDate">
                    {{ internship.startDate | date: "dd/MM/yyyy" }}
                  </div>
                  <div class="duration-endDate">
                    {{ "internships.table.to" | translate }}
                    {{ internship.endDate | date: "dd/MM/yyyy" }}
                  </div>
                </div>
              </td>
            </ng-container>

            <!-- Internships title Column -->
            <ng-container matColumnDef="internshipTitle">
              <th mat-header-cell *matHeaderCellDef>
                {{ "internships.table.title" | translate }}
              </th>
              <td mat-cell *matCellDef="let internship">
                {{ internship.availableInternshipTitle }}
              </td>
            </ng-container>

            <!-- Position Column -->
            <ng-container matColumnDef="position">
              <th mat-header-cell *matHeaderCellDef>
                {{ "internships.table.position" | translate }}
              </th>
              <td mat-cell *matCellDef="let internship">
                {{ internship.availableInternshipPosition }}
              </td>
            </ng-container>

            <!-- Department Column -->
            <!-- <ng-container matColumnDef="department">
              <th mat-header-cell *matHeaderCellDef> Department </th>
              <td mat-cell *matCellDef="let internship"> {{ internship.department }} </td>
            </ng-container> -->

            <!-- Country Column -->
            <ng-container matColumnDef="country">
              <th mat-header-cell *matHeaderCellDef>
                {{ "internships.table.country" | translate }}
              </th>
              <td mat-cell *matCellDef="let internship">
                {{
                  internship.availableInternshipCountry?.name ||
                    internship.availableInternshipCountry
                }}
              </td>
            </ng-container>

            <!-- Data Inizio Column -->
            <ng-container matColumnDef="startDate">
              <th mat-header-cell *matHeaderCellDef>Start date</th>
              <td mat-cell *matCellDef="let internship">
                {{ internship.startDate }}
              </td>
            </ng-container>

            <!-- Data Fine Column -->
            <ng-container matColumnDef="endDate">
              <th mat-header-cell *matHeaderCellDef>End date</th>
              <td mat-cell *matCellDef="let internship">
                {{ internship.endDate }}
              </td>
            </ng-container>

            <!-- Stato Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef>
                {{ "internships.table.status" | translate }}
              </th>
              <td mat-cell *matCellDef="let internship">
                {{ internship.status }}
              </td>
            </ng-container>

            <!-- Trainee Column -->
            <ng-container matColumnDef="trainee">
              <th mat-header-cell *matHeaderCellDef>
                {{ "all-trainee-assessments.table.trainee" | translate }}
              </th>
              <td mat-cell *matCellDef="let internship">
                <div class="trainee-cell">
                  <div class="trainee-name">
                    {{ internship.traineeName }}
                    {{ internship.traineeLastname }}
                  </div>
                  <div class="trainee-email">{{ internship.traineeEmail }}</div>
                </div>
              </td>
            </ng-container>

            <!-- Supervisor Column -->
            <ng-container matColumnDef="supervisor">
              <th mat-header-cell *matHeaderCellDef>
                {{ "internships.table.supervisor" | translate }}
              </th>
              <td mat-cell *matCellDef="let internship">
                <div class="trainee-cell">
                  <div class="trainee-name">
                    {{ internship.supervisorFirstname }}
                    {{ internship.supervisorLastname }}
                  </div>
                  <div class="trainee-email">
                    {{ internship.supervisorEmail }}
                  </div>
                </div>
              </td>
            </ng-container>

            <ng-container matColumnDef="questionnaire">
              <th mat-header-cell *matHeaderCellDef>
                {{ "internships.questionnaire.label" | translate }}
              </th>
              <td mat-cell *matCellDef="let internship">
                <div class="questionnaire-cell">
                  {{
                    internship.questionnaireCompiled
                      ? ("common.yes" | translate)
                      : ("common.no" | translate)
                  }}
                  <mat-icon (click)="infoDetailQuestionnaire(internship)"
                    >info</mat-icon
                  >
                </div>
              </td>
            </ng-container>
            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>
                {{ "common.action" | translate }}
              </th>
              <td mat-cell *matCellDef="let internship" class="actions-cell">
                <div class="view-icons">
                  <!-- Pulsante Visualizza -->
                  <button
                    id="description"
                    class="action-button view-action"
                    mat-icon-button
                    color="primary"
                    (click)="viewInternship(internship)"
                    [attr.aria-label]="
                      'internships.table.view-internship-aria' | translate
                    "
                  >
                    <mat-icon>list</mat-icon>
                  </button>
                  <!-- Pulsante Elimina (disabilitato se Ongoing o Completed) -->
                  <button
                    class="action-button delete-action"
                    mat-icon-button
                    color="warn"
                    (click)="deleteInternship(internship.id)"
                    [disabled]="
                      internship.status === 'Ongoing' ||
                      internship.status === 'Completed'
                    "
                    [matTooltip]="
                      internship.status === 'Ongoing' ||
                      internship.status === 'Completed'
                        ? ('internships.tooltip.cannot-delete' | translate)
                        : ('internships.tooltip.delete' | translate)
                    "
                    [attr.aria-label]="
                      'internships.table.delete-internship-aria' | translate
                    "
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <!-- Intestazione e righe -->
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          </table>
          <mat-paginator
            [pageSizeOptions]="[5, 10, 20]"
            showFirstLastButtons
          ></mat-paginator>
        </div>

        <!-- VERSIONE MOBILE "CARD STYLE" -->
        <div class="mobile-cards">
          <div *ngIf="dataSource.filteredData.length === 0" class="no-results">
            {{ "internships.no-results" | translate: { query: globalFilter } }}
          </div>

          <div
            class="internship-card"
            *ngFor="let internship of dataSource.filteredData"
          >
            <!-- HEADER -->
            <div class="card-header">
              <div>
                <div class="trainee-name">
                  {{ internship.traineeName }} {{ internship.traineeLastname }}
                </div>
                <div class="trainee-email">{{ internship.traineeEmail }}</div>
              </div>

              <div class="view-icons">
                <button
                  class="action-button view-action"
                  mat-icon-button
                  color="primary"
                  (click)="viewInternship(internship)"
                >
                  <mat-icon>list</mat-icon>
                </button>
                <button
                  mat-icon-button
                  class="action-button delete-action"
                  color="warn"
                  (click)="deleteInternship(internship.id!)"
                  [disabled]="
                    internship.status === 'Ongoing' ||
                    internship.status === 'Completed'
                  "
                  [matTooltip]="
                    internship.status === 'Ongoing' ||
                    internship.status === 'Completed'
                      ? ('internships.tooltip.cannot-delete' | translate)
                      : ('internships.tooltip.delete' | translate)
                  "
                >
                  <mat-icon>delete</mat-icon>
                </button>
              </div>
            </div>

            <!-- BODY -->
            <div class="card-body">
              <div class="info-pair">
                <div class="info">
                  <div class="label">
                    {{ "internships.table.position" | translate }}
                  </div>
                  <div class="value">
                    {{ internship.availableInternshipPosition }}
                  </div>
                </div>

                <div class="info">
                  <div class="label">
                    {{ "internships.table.country" | translate }}
                  </div>
                  <div class="value">
                    {{
                      internship.availableInternshipCountry?.name ||
                        internship.availableInternshipCountry
                    }}
                  </div>
                </div>
              </div>

              <div class="info-pair">
                <div class="info">
                  <div class="label">
                    {{ "internships.table.status" | translate }}
                  </div>
                  <div class="value">{{ internship.status }}</div>
                </div>

                <div class="info">
                  <div class="label">
                    {{ "internships.table.duration" | translate }}
                  </div>
                  <div class="value">
                    {{ internship.startDate | date: "dd/MM/yyyy" }} -
                    {{ internship.endDate | date: "dd/MM/yyyy" }}
                  </div>
                </div>
              </div>

              <div class="info-pair">
                <div class="info">
                  <div class="label">
                    {{ "internships.table.supervisor" | translate }}
                  </div>
                  <div class="value">
                    {{ internship.supervisorFirstname }}
                    {{ internship.supervisorLastname }}
                  </div>
                </div>

                <div class="info">
                  <div class="label">
                    {{ "internships.questionnaire.label" | translate }}
                  </div>
                  <div class="value">
                    {{
                      internship.questionnaireCompiled
                        ? ("common.yes" | translate)
                        : ("common.no" | translate)
                    }}
                    <mat-icon (click)="infoDetailQuestionnaire(internship)"
                      >info</mat-icon
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>

          <mat-paginator
            [pageSizeOptions]="[5, 10, 20]"
            showFirstLastButtons
          ></mat-paginator>
        </div>
      </ng-container>

      <ng-template #noInternships>
        <div class="no-internships">
          <mat-icon>info</mat-icon>
          {{ "internships.no-active" | translate }}
        </div>
      </ng-template>
    </div>
  </div>
</div>
